export enum ETipoIntegracaoPagamento {
    Nenhuma = 1,
    ASAAS = 2,
    Rede = 3,
}
